export default __webpack_public_path__ + "static/pathwise_doc_5-4dd37b9ff32bf08f024aa53c7da49919.gif";